"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleButton = exports.useToggleButton = void 0;
var React = __importStar(require("react"));
var icon_1 = require("./icon");
function useToggleButton() {
    var _a = React.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    return {
        isOpen: isOpen,
        bind: {
            onClick: function () { return setIsOpen(!isOpen); },
        },
    };
}
exports.useToggleButton = useToggleButton;
var ToggleButton = function (props) { return (React.createElement("div", __assign({ className: "PriorityNav_Button" }, props), props.children || React.createElement(icon_1.DefaultIcon, null))); };
exports.ToggleButton = ToggleButton;
